import {
  SheetPageBody,
  SheetPageClose,
  SheetPageTitle,
} from "@/components/ui/sheet-page"
import Flash from "@/components/ui/flash"
import { MailPlus } from "lucide-react"
import { useTranslation } from "react-i18next"
import { useShowProps } from "./page-props"
import { useEffect } from "react"

export default function Page() {
  const { t } = useTranslation(["school_relief_listings", "common"])
  const { relief_listing_title, school_name } = useShowProps()

  useEffect(() => {
    window.parent.postMessage("sheet:reload_on_close")
  })

  return (
    <SheetPageBody>
      <SheetPageTitle icon={MailPlus}>
        {t("school_relief_listings:applications.title", {
          title: relief_listing_title,
          school_name,
        })}
      </SheetPageTitle>
      <div className="flex flex-col gap-6 p-6">
        <Flash />
        <SheetPageClose>{t("common:actions.close")}</SheetPageClose>
      </div>
    </SheetPageBody>
  )
}
